module.exports = __webpack_public_path__ + "img/preset_item.abdd03e8.png";